/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Link } from '@coursera/cds-core';

import { SOCIAL_MEDIA_ICON_URLS } from 'bundles/page-footer/components/global-footer/constants';

import WEBSITE_ICON from 'images/shared-articles/website.png';

import _t from 'i18n!nls/shared-articles';

type SocialPlatformLinkProps = {
  url: string;
  displayUrl: string;
  iconSize?: number;
  socialPlatform?: string;
};

const SocialPlatformLink = ({ url, displayUrl, iconSize = 14, socialPlatform }: SocialPlatformLinkProps) => {
  if (!url) {
    return null;
  }

  const icon = socialPlatform
    ? SOCIAL_MEDIA_ICON_URLS[socialPlatform as keyof typeof SOCIAL_MEDIA_ICON_URLS]
    : WEBSITE_ICON;

  return (
    <Grid container spacing={8} alignItems="flex-end">
      <Grid item>
        <Imgix
          src={icon}
          alt={_t('#{platform} icon', { platform: socialPlatform || 'external website' })}
          width={iconSize}
          height={iconSize}
        />
      </Grid>
      <Grid item>
        <Link href={url} variant="standard" typographyVariant="bodyPrimary" key={url} target="_blank">
          {displayUrl}
        </Link>
      </Grid>
    </Grid>
  );
};

export default SocialPlatformLink;
